export const receiveFailureReason = {
	ediInvoiceMissing: "EDIInvoiceMissing",
	ediInvoiceMismatch: "EDIInvoiceMismatch",
	purchaseOrderClosed: "PurchaseOrderClosed",
	purchaseOrderCancelled: "PurchaseOrderCancelled",
	purchaseOrderManual: "PurchaseOrderManual",
	purchaseOrderMismatch: "PurchaseOrderMismatch",
	invoiceAlreadyUsed: "InvoiceAlreadyUsed",
};

export function receiveFailureReasonToLabelMapping(reason: string, hours: number) {
	// eslint-disable-next-line default-case
	switch (reason) {
		case receiveFailureReason.ediInvoiceMissing:
			if (hours >= 48) {
				return "EDI missing 48+ hours";
			} else if (hours >= 24) {
				return "EDI missing 24+ hours";
			} else {
				return "EDI missing";
			}
		case receiveFailureReason.ediInvoiceMismatch:
			return "EDI mismatch";
		case receiveFailureReason.purchaseOrderClosed:
			return "Purchase order closed";
		case receiveFailureReason.purchaseOrderCancelled:
			return "Purchase order cancelled";
		case receiveFailureReason.purchaseOrderManual:
			return "Purchase order manual";
		case receiveFailureReason.purchaseOrderMismatch:
			return "Purchase order mismatch";
		case receiveFailureReason.invoiceAlreadyUsed:
			return "Invoice already used";
		default:
			return "Unknown failure occurred";
	}
}

export function receiveFailureReasonToInstruction(reason: string) {
	// eslint-disable-next-line default-case
	switch (reason) {
		case receiveFailureReason.ediInvoiceMissing:
			return "EDI Invoice has not yet been received from the supplier. Please log each receiving issue via JB Intranet > Invoices > EDI Invalid Invoice to have this resolved.";
		case receiveFailureReason.ediInvoiceMismatch:
			return "EDI Invoice does not match what has been received, check each line vs what was physically received.";
		case receiveFailureReason.purchaseOrderClosed:
			return "Purchase order has been closed and could not be reopened when attempting to finalise. Check each line vs what is in Shopkeeper.  You may need to clear this receive & process in Shopkeeper directly.";
		case receiveFailureReason.purchaseOrderCancelled:
			return "Purchase order has been cancelled and could not be reopened when attempting to finalise. Check each line vs what is in Shopkeeper. You may need to clear this receive & process in Shopkeeper directly.";
		case receiveFailureReason.purchaseOrderManual:
			return "Purchase order manual";
		case receiveFailureReason.purchaseOrderMismatch:
			return "Receive does not match the purchase order. Either SKUs or Quantities do not match. Check each line vs what is in Shopkeeper. You may need to clear this receive & process in Shopkeeper directly. ";
		case receiveFailureReason.invoiceAlreadyUsed:
			return "Invoice has already been used. Somehow this has gone past our validation & you'll likely need to clear this receive & process directly in Shopkeeper by appending an A to the end of the invoice number.";
		default:
			return "This receive has failed to finalise but we're not sure why! Please raise a Zendesk ticket with IT Support.";
	}
}

export const failureReasonsRequiringInterventionCsv = `${receiveFailureReason.purchaseOrderMismatch},${receiveFailureReason.invoiceAlreadyUsed},${receiveFailureReason.ediInvoiceMismatch},${receiveFailureReason.purchaseOrderClosed},${receiveFailureReason.purchaseOrderCancelled},`;
